import React, { PropTypes, Component } from 'react';
import Footer from '../footer/Footer';

class LoginLayout extends Component {
  render() {
    return (
      <div>
        {this.props.children}
        <Footer variant="white" />
      </div>
    );
  }
}

LoginLayout.propTypes = {
  children: PropTypes.object
};

export default LoginLayout;



// WEBPACK FOOTER //
// ./src/layouts/global/LoginLayout.js